// https://tanstack.com/query/v3/docs/react/reference/useQuery
export const DEFAULT_QUERY_OPTIONS: Partial<Record<string, any>> = {
  staleTime: 60 * 1000, // 1 minute
};
